import { render, staticRenderFns } from "./CustomSortEdit.vue?vue&type=template&id=f9a5958e&scoped=true&"
import script from "./CustomSortEdit.vue?vue&type=script&lang=js&"
export * from "./CustomSortEdit.vue?vue&type=script&lang=js&"
import style0 from "./CustomSortEdit.vue?vue&type=style&index=0&id=f9a5958e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a5958e",
  null
  
)

export default component.exports